/**
 * CMCD `json` transmission mode.
 *
 * @group CMCD
 *
 * @beta
 *
 * @deprecated JSON transmission mode is deprecated and will be removed in future versions.
 */
export const CMCD_JSON = 'json';
//# sourceMappingURL=CMCD_JSON.js.map